import ChatModel from '../model/chat';
export const GET_CHAT = 'GET_CHAT';

const messageSortValue = (row) => {
  if (row.created_at != null && row.created_at !== '') {
    const numeric = Number(row.created_at);
    if (!Number.isNaN(numeric) && numeric > 0) return numeric;
    const parsed = new Date(row.created_at).getTime();
    if (!Number.isNaN(parsed)) return parsed;
  }
  const clock = /^(\d{1,2}):(\d{2})$/.exec(String(row.time || ''));
  if (clock) return parseInt(clock[1], 10) * 60 + parseInt(clock[2], 10);
  return 0;
};

export const get_chat = (to_user) =>{
return async (dispatch,getState) =>{
  const from_user = getState().authReduse.id;
  const res= await fetch(`/api/cn/chat/${from_user}/${to_user}`);
  if (!res.ok) throw new Error('Could not load messages');
  const resses = await res.json();
  const ress = Array.isArray(resses.msg) ? [...resses.msg] : [];
  ress.sort((a, b) => messageSortValue(a) - messageSortValue(b));
  const data = ress.map(row => new ChatModel(
    row.id,
    row.from_user,
    row.to_user,
    row.content,
    row.time,
    row.delivered ? 'delivered' : 'sent'
  ));
  dispatch({type:GET_CHAT,data:data,info:resses.msg2?.[0] || {}})
}}
